import { init } from '@rematch/core';
import createLoadingPlugin from '@rematch/loading';
import { createLogger } from 'redux-logger';

import App from './model';
import Index from '../index/model';

const middlewares = [];
const options = {};

if (process.env.NODE_ENV === 'development') {
  const logger = createLogger({
    collapsed: true,
    duration: true,
    logErrors: true,
  });
  middlewares.push(logger);
}

const models = {
  App,
  Index,
};
const loading = createLoadingPlugin(options);

const store = init({
  plugins: [loading],
  models,
  redux: {
    initialState: {},
    middlewares,
  },
});

export default store;
